export const largeNavHeight = '7.75rem'
export const smallNavHeight = '4.1rem'

export const sosSpecialTopicCategory = "SOSSpecialTopicCategory";
export const sosOffer = "SOSOffer";
export const sosSpecialTopic = "SOSSpecialTopic";
export const sosNews = "SOSNews";
export const sosPublication = "SOSPublication";
export const sosEvent = "SOSEvent";
export const sosPressrelease = "SOSPressrelease";
export const sosDonationProduct = "SOSDonationProduct";
export const sosDonationCertificate = "SOSDonationCertificate";
export const queryList = "CMQueryList";
export const cart = "warenkorb";
export const viewTypeSpecialTopic = "specialTopicModule";

export const placement_header = "header";
export const placement_stageteaser = "stageteaser";
export const placement_footer = "footer";
export const placement_topnavi = "topnavi";

export enum PageContentType {
    Cart = "Cart",
    Special = "Special",
    Standard = "Standard",
    Product = "Product"
}

export function getPageContentType(contentType: string, currentURL?:string): PageContentType {
    if (isCart(currentURL)) {
        return PageContentType.Cart;
    }
    switch (contentType) {
        case sosEvent:
        case sosNews:
        case sosPressrelease:
        case sosPublication:
            return PageContentType.Special;
        default:
            return PageContentType.Standard;
    }
}

export function isProductPage(page: any) {
    return page.type === sosDonationProduct;
}

export function isOfferPage(page: any) {
    return page.type === sosOffer;
}

export function isCart(currentURL?: string) {
    return currentURL?.endsWith(cart)
}

export function isSpecialTopicPage(page: any): boolean {
    return (page.__typename !== undefined &&
            (page.__typename == 'SOSSpecialTopicCategoryImpl' || page.__typename == 'SOSSpecialTopicImpl'))
        || (page.type !== undefined &&
            (page.type === sosSpecialTopicCategory || page!.type === sosSpecialTopic))

}

export function isPageType(page: any) {
    return typeof page === "string" ?
        (page === "CMChannel" ||
            page === 'SOSWimmelbild' ||
            page === 'SOSOrganisation' ||
            page === sosOffer ||
            page == sosDonationProduct ||
            page == sosSpecialTopicCategory ||
            page == sosSpecialTopic)
        : (page.__typename != undefined && (
            page.__typename == 'CMChannelImpl' ||
            page.__typename == 'SOSOfferImpl' ||
            page.__typename == 'SOSOrganisationImpl' ||
            page.__typename == 'SOSSpecialTopicCategoryImpl' ||
            page.__typename == 'SOSSpecialTopicImpl'));
}

export function isPagelikeContent(page: any) {
    return typeof page === "string" ?
        getPageContentType(page) === PageContentType.Special
        : (page.__typename != undefined && (
            page.__typename == 'SOSEventImpl' ||
            page.__typename == 'SOSPublicationImpl' ||
            page.__typename == 'SOSNewsImpl' ||
            page.__typename == 'SOSPressreleaseImpl'
        ))
}

export function isBlankPage(fragment: any) {
    return fragment.grid?.name === "SOS Blank Page"
}

export function isWimmelbild(fragment: any) {
    return (fragment.type !== undefined && fragment.type === "SOSWimmelbild")
        || (fragment.__typename !== undefined && fragment.__typename == 'SOSWimmelbildImpl')
}

export function isPageWithHiddenNavi(page: any) {
    return page.grid && page.grid.name === "SOS Seite ohne Navigation"
}